export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// ./~/d3-chord/src/array.js
// module id = 474
// module chunks = 4